import { ThemeProvider as NextThemeProvider } from '@emotion/react'
import React from 'react'
import { ScreenClassProvider } from 'react-grid-system'
import Helmet from 'react-helmet'
import { I18nextProvider } from 'react-i18next'
import { Provider } from 'react-redux'
import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import { createLogger } from 'redux-logger'

import { CategoriesProvider, PostsProvider } from '../hooks'
import i18next from '../i18n/config'
import { OneLinkProvider } from '../modules/components/hooks/useOneLink.tsx'
import nextTheme from '../modules/next-theme'
import { ThemeGlobalStyle, ThemeProvider } from '../modules/theme.jsx'
import rootReducers from '../redux/reducers'

const wrapRootElement = ({ element }) => {
  const store = createStore(
    rootReducers,
    composeWithDevTools(applyMiddleware(createLogger()))
  )

  return (
    <>
      <Helmet
        bodyAttributes={{
          class: 'fs-unmask',
        }}
      >
        <script src="https://cdn.optimizely.com/js/22092170568.js"></script>
        <script
          src="//cdn.cookielaw.org/scripttemplates/otSDKStub.js"
          type="text/javascript"
          charSet="UTF-8"
          data-domain-script={process.env.GATSBY_COOKIE_LAW}
          async
        ></script>
        <script>{'function OptanonWrapper() {}'}</script>
        <script src="/lib/gt.js"></script>
      </Helmet>

      {/* <FixedGlobalStyle /> */}
      <I18nextProvider i18n={i18next}>
        <PostsProvider>
          <CategoriesProvider>
            <Provider store={store}>
              <NextThemeProvider theme={nextTheme}>
                <ThemeProvider>
                  <ScreenClassProvider>
                    <OneLinkProvider>
                      <ThemeGlobalStyle />
                      {element}
                    </OneLinkProvider>
                  </ScreenClassProvider>
                </ThemeProvider>
              </NextThemeProvider>
            </Provider>
          </CategoriesProvider>
        </PostsProvider>
      </I18nextProvider>
    </>
  )
}

export default wrapRootElement
